"use strict";

import axios from "axios";
import config from "../config/config";

export function decodeJwtPayload(token) {
  try {
    const payload = String(token || "").split(".")[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
    return JSON.parse(window.atob(padded));
  } catch (_err) {
    return null;
  }
}

export function isJwtExpired(token, nowMs = Date.now()) {
  const payload = decodeJwtPayload(token);
  const expSeconds = Number(payload?.exp || 0);
  if (!expSeconds) return true;
  return nowMs >= expSeconds * 1000;
}

export function clearStoredAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("userid");
  localStorage.removeItem("role");
  localStorage.removeItem("firstname");
  localStorage.removeItem("lastname");
}

export function storeAuthenticatedUser(user = {}) {
  const userid = String(user.userid || "").trim();
  const role = String(user.role || "").trim();
  const firstname = String(user.firstname || "").trim();
  const lastname = String(user.lastname || "").trim();

  if (userid) localStorage.setItem("userid", userid);
  else localStorage.removeItem("userid");

  if (role) localStorage.setItem("role", role);
  else localStorage.removeItem("role");

  if (firstname) localStorage.setItem("firstname", firstname);
  else localStorage.removeItem("firstname");

  if (lastname) localStorage.setItem("lastname", lastname);
  else localStorage.removeItem("lastname");

  // Alte Bearer-Reste aktiv abbauen.
  localStorage.removeItem("token");
}

export function getStoredIdentity() {
  return {
    userid: String(localStorage.getItem("userid") || "").trim(),
    role: String(localStorage.getItem("role") || "").trim(),
    firstname: String(localStorage.getItem("firstname") || "").trim(),
    lastname: String(localStorage.getItem("lastname") || "").trim(),
  };
}

export function buildAuthHeaders(extraHeaders = {}) {
  return { ...(extraHeaders || {}) };
}

export function buildAuthRequestConfig(options = {}) {
  return {
    ...options,
    withCredentials: true,
    headers: buildAuthHeaders(options.headers || {}),
  };
}

export function buildAuthFetchOptions(options = {}) {
  return {
    ...options,
    credentials: options.credentials || "include",
    headers: buildAuthHeaders(options.headers || {}),
  };
}

export async function logoutCurrentSession() {
  try {
      await axios.post(
      `${config.API_BASE_URL}/api/logout`,
      {},
      buildAuthRequestConfig()
    );
  } catch (_err) {
    // Best effort: lokaler Logout darf nicht an einem Netzwerkfehler haengen.
  } finally {
    clearStoredAuth();
  }
}
